import clsx from 'clsx'

export default function Circle({ color, className }: { color: '#F2DFCE' | '#B0CBD3'; className: string }) {
  return (
    <svg className={clsx(className && `${className}`)} viewBox="0 0 793 793" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="396.5" cy="396.5" r="396.5" fill={color} />
    </svg>
  )
}
